import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import "./common.css";
const CommonStaticDropdown = ({
  apiUrl,
  items: staticItems = [],
  placeholder = "Select",
  onSelect,
  value,
  enableSearch = true, // ✅ new prop to enable/disable search
}) => {
  const [items, setItems] = useState(staticItems);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async (query = "") => {
    if (!apiUrl) return;
    try {
      setLoading(true);
      const res = await fetch(`${apiUrl}${query}`);
      const data = await res.json();
      if (data.success === true) {
        setItems(data.suggestionlist);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!apiUrl && staticItems.length > 0) {
      setItems(staticItems);
    } else {
      fetchData();
    }
  }, [apiUrl, staticItems]);

  useEffect(() => {
    setSelected(value);
  }, [value, items]);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (apiUrl) {
      fetchData(term);
    } else {
      const filtered = staticItems.filter((item) =>
        item.label.toLowerCase().includes(term.toLowerCase())
      );
      setItems(filtered);
    }
  };

  const handleSelect = (item) => {
    setSelected(item);
    if (onSelect) onSelect(item);
  };

  return (
    <Dropdown className="w-100">
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className="bg-transparent w-100 text-black d-flex justify-content-between dp-toggle"
      >
        <span style={{ color: selected ? "#212129" : "#888888" }}>
          {selected ? selected.label : placeholder}
        </span>
        <span className="text-black">
          <ChevronDown />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-2 w-100"
        style={{ maxHeight: "300px", overflowY: "auto" }}
      >
        {enableSearch && (
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
            className="mb-2"
          />
        )}

        {loading && (
          <div className="px-2 text-muted">
            <Spinner size="sm" /> Loading...
          </div>
        )}

        {!loading && items.length > 0 ? (
          items.map((item) => (
            <Dropdown.Item
              key={item.value}
              onClick={() => handleSelect(item)}
              className="text-black dropdown-item-hover"
            >
              {item.label}
            </Dropdown.Item>
          ))
        ) : !loading ? (
          <div className="px-2 text-muted">No results found</div>
        ) : null}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CommonStaticDropdown;
